import { Close } from "@mui/icons-material";
import { Box, Button, Divider, IconButton, Modal, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthInput from "../../recruiter/components/AuthController/AuthInput";

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  width: "90%",
  bgcolor: "white",
  paddingX: 5,
  paddingY: 3,
  borderRadius: "18px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const regExp =
  /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

const validationSchema = Yup.object().shape({
  url: Yup.string()
    .required("Youtube link cannot be empty")
    .test("Valid Youtube Link", "Invalid Youtube link", (value) =>
      regExp.test(value)
    ),
});

const VideoUploader = ({ open, onClose, onSubmit }) => {
  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: { url: "" },
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (open) setValue("url", "");
    else clearErrors();
  }, [open]);

  const onSubmitData = async (data) => {
    onSubmit({ ...data });
  };

  return (
    <Modal
      disableAutoFocus
      sx={{ bgcolor: "#F4F4F499" }}
      hideBackdrop
      open={open}
    >
      <Box className="shadow-[0_0_14px_grey]" sx={boxStyle}>
        <IconButton
          onClick={onClose}
          className="absolute top-3 right-3"
          size="small"
        >
          <Close className="text-xl" />
        </IconButton>
        <Box className="mb-6">
          <h2 className="font-['Poppins-Medium'] font-[500] text-center text-[16px]">
            Upload your profile video/YouTube work links
          </h2>
        </Box>
        <Stack className="w-full" my={1}>
          <AuthInput
            placeholder="Enter Link"
            hookFormControl={control}
            varName="url"
            size="small"
            errorMessage={errors?.url?.message}
          />
        </Stack>
        <Button
          onClick={handleSubmit(onSubmitData)}
          className="bg-[#2F80ED] text-[#FFF] w-full rounded-full my-2 font-['Poppins-Medium'] font-[500]"
        >
          Submit
        </Button>
      </Box>
    </Modal>
  );
};

export default React.memo(VideoUploader, (prevProps, nextProps) => {
  return prevProps.open === nextProps.open;
});
